import { setHeader, TEST_API } from "..";
import axios from "axios";

const deeplinkApi = {
  checkPending: () => {
    const config = {
      method: "GET",
      baseURL: `${TEST_API}/deep-link/check-pending`,
      headers: setHeader(),
    };
    return axios(config).then((res) => res.data);
  },
  clearPending: () => {
    const config = {
      method: "POST",
      baseURL: `${TEST_API}/deep-link/clear-pending`,
      headers: setHeader(),
    };
    return axios(config).then((res) => res.data);
  },
  validateToken: (token) => {
    const config = {
      method: "GET",
      baseURL: `${TEST_API}/deep-link/validate?token=${token}`,
      headers: setHeader(),
    };
    return axios(config).then((res) => res.data);
  },
};

export default deeplinkApi;
